module.exports = __webpack_public_path__ + "static/jason-b1f28547577aef072ff740193fe899de.png";